import React, { useContext } from 'react';
import styled from 'styled-components';
import { ApplicationUIContext } from '@yuhuinc/ui-library';

import { Steps, Button, Space, Typography, Row } from 'antd';
import { FileTextOutlined, CaretRightOutlined, CaretDownOutlined } from '@ant-design/icons';

import { redirectToApplicationPage } from 'helpers/SignDocumentURL';

const { Step } = Steps;
const { Text, Title } = Typography;

const StyledSteps = styled(Steps)`
  margin-top: 12px;
`;

const StyledButton = styled(Button)`
  width: 100%;
`;

const StyledCaretRight = styled(CaretRightOutlined)`
  margin-top: 14px;
`;

const StyledCaretDown = styled(CaretDownOutlined)`
  margin-top: 14px;
`;

const IN_PROGRESS = 'in_progress';
const SUBMITTED = 'submitted';
const APPROVED = 'approved';
const LEASE_IN_PROGRESS = 'lease_in_progress';
const LEASE_COMPLETED = 'lease_completed';
const ADDING_DETAILS = 'adding_details';
const CHANGE_CONSENT_REQUIRED = 'change_consent_required';

const StatusMapping = {
  in_progress: 0,
  submitted: 1,
  approved: 2,
  lease_in_progress: 3,
  lease_completed: 4,
};

const ApplicationSteps = [
  { title: 'Application in progress', status: IN_PROGRESS },
  { title: 'Application submitted', status: SUBMITTED },
  { title: 'Application approved', status: APPROVED },
  { title: 'Lease in progress', status: LEASE_IN_PROGRESS },
  { title: 'Lease completed', status: LEASE_COMPLETED },
];

const SideBarStepper = ({ cotenant, showSummary }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  const cotenantStatus = cotenant.lifecycle?.status;
  const cotenantSubstatus = cotenant.lifecycle?.substatus;
  let applicationStatus = cotenant.application?.lifecycle?.status;
  const applicationSubstatus = cotenant.application?.lifecycle?.substatus;

  // TODO: how tenant status influences application status
  if (applicationStatus === IN_PROGRESS && cotenantStatus === SUBMITTED) {
    applicationStatus = SUBMITTED;
  }

  const canStartApplication = cotenantStatus === IN_PROGRESS;
  const canContinueApplication =
    [IN_PROGRESS, ADDING_DETAILS].includes(cotenantSubstatus) ||
    [CHANGE_CONSENT_REQUIRED].includes(applicationSubstatus);

  function redirectActionButton() {
    // TODO: route to lease signing when ready
    redirectToApplicationPage(cotenant.application?.property?.unique_id, cotenant.application_id);
  }

  return (
    <>
      {isMobile ? (
        <Row justify="space-between">
          <Space>
            <FileTextOutlined />
            <Title level={4}>Application status</Title>
          </Space>
          {showSummary ? <StyledCaretRight /> : <StyledCaretDown />}
        </Row>
      ) : (
        <Space>
          <FileTextOutlined />
          <Text strong>Application status</Text>
        </Space>
      )}
      {showSummary ? (
        <StyledSteps size="small" direction="vertical" current={StatusMapping[applicationStatus]}>
          {ApplicationSteps.map((step) => (
            <Step key={step.status} title={step.title} />
          ))}
        </StyledSteps>
      ) : (
        <StyledSteps
          size="small"
          direction="vertical"
          current={StatusMapping[applicationStatus]}
          progressDot
        >
          {ApplicationSteps.filter((step) => step.status === applicationStatus).map((step) => (
            <Step key={step.status} title={step.title} />
          ))}
        </StyledSteps>
      )}
      {(canStartApplication || canContinueApplication) && (
        <StyledButton type="primary" size="medium" onClick={redirectActionButton}>
          {canContinueApplication ? 'Continue Application' : 'Start Application'}
        </StyledButton>
      )}
    </>
  );
};

export default SideBarStepper;
